<div *ngIf="type === 'BUBBLE'" id="bubble">
  <div *ngIf="user">
    <button *ngIf="!backgroundImage"
            type="button"
            matTooltip="{{user.fullName}} {{role?.name}}"
            (click)="openUserDialog()">
      {{initials}}
    </button>
    <img *ngIf="backgroundImage"
         [src]="backgroundImage"
         alt="{{initials}}"
         matTooltip="{{user.fullName}} {{role?.name}}"
         (click)="openUserDialog()">
  </div>
</div>
<div *ngIf="user && type === 'TEXT'" id="text">
  <button type="button" matTooltip="Click to View Details" (click)="openUserDialog()">
    <div>{{user.fullName}}</div>
    <div *ngIf="role?.name">{{role.name}}</div>
  </button>
</div>
